<template>
  <div>
    <div class="wrap-top-blocks flex-container ">
      <div class="block-rect">
        <template v-if="evaluationResults_status.is_loading">
          <Preloader></Preloader>
        </template>
        <template v-else>
          <template v-if="!evaluationResults">
            <div class="comparison-level-title">
              No data
            </div>
          </template>
          <template v-else>
            <div v-if="show_advanced" class="d-flex justify-content-center">
              <b-button-group>
                <b-button class="result-selector-button" size="sm"
                  :variant="programsSelector === 'basic' ? 'primary' : 'light'" @click="toggle_view"><img
                    :src="getSwitcherIconPath('basic-btn')" alt=""><span>Basic</span></b-button>
                <b-button class="result-selector-button" size="sm"
                  :variant="programsSelector === 'advanced' ? 'primary' : 'light'"
                  @click="toggle_view">
                  <img :src="getSwitcherIconPath('advanced-btn')" alt="" />
                  <span>Advanced</span>
                </b-button>
              </b-button-group>
            </div>
            <table class="styled-table">
              <thead>
                <tr>
                  <th :width="programs.length < 3 ? undefined : '30%'"></th>
                  <th v-for="program in programs" :key="program" :colspan="!is_single(program) ? '2' : undefined">
                    {{ show_ideal_match_prefix ? `Ideal Match - ` : '' }}{{ selected_programs[program] }}
                  </th>
                </tr>
                <tr v-if="singles.length !== programs.length">
                  <th></th>
                  <template v-for="program in programs">
                    <template v-if="is_single(program)">
                      <th :key="program + '-regular'"></th>
                    </template>
                    <template v-else>
                      <th class="table-subheader" :key="program + '-wide'">wide</th>
                      <th class="table-subheader" :key="program + '-narrow'">narrow</th>
                    </template>
                  </template>
                </tr>
              </thead>

              <tbody>
                <tr v-for="indicator in indicators" :key="indicator.field">
                  <td>{{ indicator.name }}</td>
                  <template v-for="program in programs">
                    <template v-if="is_single(program)">
                      <td :key="program + '-regular'">
                        {{ indicator.formatterFn(opts[program]['regular'][indicator.field], opts[program]['regular']) }}
                      </td>
                    </template>
                    <template v-else>
                      <td :key="program + '-wide'">
                        {{ indicator.formatterFn(opts[program]['wide'][indicator.field], opts[program]['wide']) }}
                      </td>
                      <td :key="program + '-narrow'">
                        {{ indicator.formatterFn(opts[program]['narrow'][indicator.field], opts[program]['narrow']) }}
                      </td>
                    </template>
                  </template>
                </tr>
              </tbody>
            </table>
          </template>
        </template>
      </div>
    </div>

    <div class="">
      <FullReport></FullReport>
    </div>
  </div>
</template>

<script>
import FullReport from "@/views/results/FullReport";
import Preloader from "@/components/Preloader";
import { mapGetters } from "vuex";
import { buildOptionsMap } from "@/store/sample";
import { number, currency } from '@/utils'

import AdvancedDefaultIcon from '../assets/icon-advanced-default.svg'
import AdvancedActiveIcon from '../assets/icon-advanced-active.svg'
import BasicDefaultIcon from '../assets/icon-basic-default.svg'
import BasicActiveIcon from '../assets/icon-basic-active.svg'


const VIEW_BASIC = 'basic'
const VIEW_ADVANCED = 'advanced'

const affn = (v, opts) => {
  if (opts['affHousingFloorAreaUAP'] !== null)
    return `UAP Floor Area: ${number(opts['affHousingFloorAreaUAP'])}\n485x Floor Area: ${number(opts['affHousingFloorArea485X'])}`
  return number(v)
}

export default {
  name: "Results",
  components: {
    FullReport,
    Preloader
  },
  data: () => ({
    programsSelector: VIEW_ADVANCED,
    programBasicNames: { 'none': "No Programs/\nAs of Right", 'x485': "485x Only", 'uap': "485x + UAP" },
    programAdvancedNames: { 'avoid_prev_wages': "Avoid Wages", 'avoid_40_ami': "Avoid 40% AMI", 'ideal_match': "Ideal Match", 'ideal_match_small_project': "Small Project" },
    types: ['regular', 'wide', 'narrow'],
    indicators: [
      { name: "Max Res Floor Area", field: "maxResFloorArea", formatterFn: number },
      { name: "Max # of Res Units", field: "maxNumberOfResUnits", formatterFn: number },
      { name: "Affordable Housing Floor Area", field: "affHousingFloorArea", formatterFn: affn },
      {
        name: "Projected # of Affordable Units and AMI level", field: "projNumberOfAffHousingUnitsSet", formatterFn: v => {
          return v.map(item => `${item.numberOfUnits} at ${item.ami}% AMI`).join('\n')
        }
      },
      { name: "Projected # of Free Market Units", field: "projNumberOfFreeMarketUnits", formatterFn: number },
      { name: "Post Completion Property Tax", field: "postCompletionPropTax", formatterFn: currency },
      { name: "Tax Savings", field: "taxSavingsPerYear", formatterFn: currency }
    ]
  }),
  computed: {
    ...mapGetters({
      bblId: 'get_bblId',
      area_custom: 'get_area_custom',
      evaluationResults: 'get_evaluationResults',
      evaluationResults_status: 'get_evaluationResults_status',
    }),
    opts() {
      if (this.evaluationResults?.options) {
        return buildOptionsMap(this.evaluationResults.options, this.selected_programs_keys)
      }
      return {}
    },
    selected_programs_basic() {
      if (!this.evaluationResults?.options) return {}
      const allProgramsList = this.evaluationResults.options.map(item => item.program).filter((v, i, a) => a.indexOf(v) === i);
      return Object.keys(this.programBasicNames).reduce((acc, key) => {
        if (allProgramsList.includes(key)) {
          acc[key] = this.programBasicNames[key];
        }
        return acc;
      }, {});
    },
    selected_programs_advanced() {
      if (!this.evaluationResults?.options) return {}
      const allProgramsList = this.evaluationResults.options.map(item => item.program).filter((v, i, a) => a.indexOf(v) === i);
      const r =  Object.keys(this.programAdvancedNames).reduce((acc, key) => {
        if (allProgramsList.includes(key)) {
          acc[key] = this.programAdvancedNames[key];
        }
        return acc;
      }, {});

      console.log('Selected Programs Advanced:', r, this.evaluationResults.options, allProgramsList)

      // if r contains key 'ideal_match_small_project' return only this key
      if (r['ideal_match_small_project']) {
        return { 'ideal_match_small_project': r['ideal_match_small_project'] }
      }
      return r
    },
    rule_none_more_than_90000() {
      const maxResFloorArea = this.opts['none']?.['regular']?.['maxResFloorArea'];
      console.log('Max Res Floor Area:', maxResFloorArea, this.opts);
      return Number(maxResFloorArea) > 90000;
    },
    show_advanced() {
      return !this.rule_none_more_than_90000
        && Object.keys(this.selected_programs_advanced).length > 0
    },
    selected_programs() {
      return this.programsSelector === VIEW_BASIC ? this.selected_programs_basic : this.selected_programs_advanced
    },
    selected_programs_keys() {
      return Object.keys(this.selected_programs)
    },
    show_ideal_match_prefix() {
      return this.programsSelector === VIEW_ADVANCED && this.selected_programs_keys.length === 1 && this.selected_programs_keys[0] !== 'ideal_match'
    },
    singles() {
      if (!this.evaluationResults) return []
      return this.selected_programs_keys.filter(program => this.opts[program]['regular'])
    },
    programs() {
      if (this.evaluationResults) {
        return Object.keys(this.opts).sort((a, b) => {
          return this.selected_programs_keys.indexOf(a) - this.selected_programs_keys.indexOf(b);
        });
      }
      return [];
    }
  },
  watch: {
    show_advanced: {
      immediate: true,
      handler(newVal) {
        console.log('show_advanced', newVal, this)
        if (this.programsSelector === VIEW_ADVANCED && !newVal) {
          this.programsSelector = VIEW_BASIC
        }
        if (this.programsSelector === VIEW_BASIC && newVal) {
          this.programsSelector = VIEW_ADVANCED
        }
      },
    },
  },
  created() {
    // console.log('created resultz.vue', Date.now())
    this.getData()
  },
  methods: {
    toggle_view() {
      this.programsSelector = this.programsSelector === VIEW_BASIC ? VIEW_ADVANCED : VIEW_BASIC
    },
    is_single(program) {
      return this.singles.includes(program)
    },
    getData() {
      if (!this.bblId) return false
      this.$store.dispatch('evaluateResults')
    },
    getSwitcherIconPath(button) {
      if (button === 'basic-btn')
        return this.programsSelector === VIEW_BASIC ?
          BasicActiveIcon :
          BasicDefaultIcon
      else if (button === 'advanced-btn')
        return this.programsSelector === VIEW_ADVANCED ?
          AdvancedActiveIcon :
          AdvancedDefaultIcon
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

.result-selector-button {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 10px 16px;
  width: 120px;
}

.btn-primary {
  color: #fff;
  background-color: $font-blue;
  border-color: $font-blue;

  &:focus,
  &.focus {
    box-shadow: none;
  }
}

.btn-light {
  color: $font-black;
  background-color: $light-blue;
  border-color: #b8c3d6;
}

.rectangle-square {
  height: 91px;
  width: 91px;
  border-radius: 10px;
  padding: 10px;
  transition-duration: 0.4s;
  transition-timing-function: ease-in;
}

.white-rect {
  border: 1px solid #E6E8FF;
}

.line-arrow {
  line-height: 16px;
  margin-bottom: auto;
  fill: $font-black;
}

.recomm-emoji {
  width: 38px;
}

.icon-recommend {
  margin: 19px;
}

.wrap-comparison-level-percent {
  height: 115px;
  width: 376px;
  border-radius: 8px;
  background-color: rgba(171, 200, 239, .1);
  padding: 12px;
  margin-top: 12px;
}

.speedometer-wrapper {
  border-bottom: 1px solid rgba(150, 168, 190, .2);
  margin-bottom: 11px;
  padding-bottom: 11px;
  text-align: center;
  position: relative;
}

.speedometer-arrow {
  position: absolute;
  bottom: 2px;
  left: 105px;
  -webkit-transform-origin: 85% 85%;
  -moz-transform-origin: 85% 85%;
  -o-transform-origin: 85% 85%;
  -ms-transform-origin: 85% 85%;
  transition-duration: 0.4s;
  transition-timing-function: ease-in;

}

.speedometer-arrow-0 {
  transform: rotate(-46deg);
}

.speedometer-arrow-1 {
  transform: rotate(-35deg);
}

.speedometer-arrow-2 {
  transform: rotate(-23deg);
}

.speedometer-arrow-3 {
  transform: rotate(2deg);
}

.speedometer-arrow-4 {
  transform: rotate(14deg);
}

.speedometer-arrow-5 {
  transform: rotate(39deg);
}

.speedometer-arrow-6 {
  transform: rotate(52deg);
}

.speedometer-arrow-7 {
  transform: rotate(77deg);
}

.speedometer-arrow-8 {
  transform: rotate(89deg);
}

.speedometer-arrow-9 {
  transform: rotate(113deg);
}

.speedometer-arrow-10 {
  transform: rotate(125deg);
}

.wrap-top-blocks {
  margin-top: 0;
}

.fb-logo {
  background: url('../assets/facebook_logo.svg') no-repeat center;
}

.gm-logo {
  background: url('../assets/google_logo.svg') no-repeat center;
}

.fb-logo,
.gm-logo {
  background-position-x: 9px;
  background-position-y: 5px;
}

.arrow-up {
  height: 12px;
  width: 20px;
  margin-left: 8px;
}

.block-rect {
  width: 100%;
  min-height: 300px;
  border-radius: 12px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 8px 0 rgba(26, 41, 60, 0.1);
  margin-bottom: 24px;
  padding: 24px;
}

.basic-and-recomm {
  height: 214px;
}

.assess-level {
  height: 370px;
  width: 424px;
}

.assess-level-title {
  color: #8ECC31;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: -0.35px;
  line-height: 27px;
  margin-bottom: 2px;
  transition-duration: 0.4s;
  transition-timing-function: ease-in;
  text-align: center;
}

.assess-level-subtitle {
  color: $font-gray;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 19px;
  text-align: center;
}

.assess-level-text {
  color: $font-black;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
}

.assess-level-text p {
  margin-bottom: 6px;
  padding-left: 20px;
  position: relative;
}

.assess-level-text p:before {
  content: '';
  position: absolute;
  left: 0;
  top: 5px;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #082E60;
}

.assess-level-text p.severely-underassessed:before {
  background: #80B926;
}

.assess-level-text p.moderately-underassessed:before {
  background: #A7DC59;
}

.assess-level-text p.fairly-assessed:before {
  background: #FFE086;
}

.assess-level-text p.moderately-overassessed:before {
  background: #FFB57B;
}

.assess-level-text p.severely-overassessed:before {
  background: #FF7564;
}

.comparison {
  height: 370px;
  width: 424px;
  margin-left: 24px;
}

.comparison-level-title {
  color: $font-black;
  font-size: 20px;
  letter-spacing: -0.35px;
  line-height: 27px;
  margin-bottom: 2px;
  text-align: center;
}

.comparison-level-subtitle {
  color: $font-gray;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 24px;
  text-align: center;
}

.comparison-level-percent {
  color: $font-black;
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -0.56px;
  font-family: "Open Sans";
  line-height: 27px;
  position: relative;
  margin-bottom: 0;
}

.arrow-img {
  content: '';
  position: absolute;
  top: 0;
  right: -30px;
  display: block;
  width: 20px;
  height: 12px;
}

.comparison-level-percent-description {
  height: 44px;
  width: 185px;
  color: $font-black;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
  margin: 24px auto;
}

.comparison-details {
  border-radius: 8px;
  width: 100%;
  padding: 12px;
  background-color: rgba(171, 200, 239, .1);

}

.comparison-details-perceived {
  height: 44px;
  border-radius: 8px;
  color: #0A1250;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  padding: 11px 16px;
  margin-bottom: 8px;
  transition-duration: 0.4s;
  transition-timing-function: ease-in;
  min-width: 72px;
}

.comparison-details-perceived.perc-brdr {
  border: 1px solid #CDD1FF;
}

.comparison-details-perceived.perc-fll {
  background-color: #CDD1FF;
}

.comparison-details-perceived span {
  font-weight: 600;
  color: $font-black;
  margin-left: 5px;
}


.comparison-details-actual {
  height: 44px;
  border-radius: 8px;
  min-width: 72px;
  color: #0A1250;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  padding: 11px 16px;
  margin-bottom: 0;
  transition-duration: 0.4s;
  transition-timing-function: ease-in;
}

.comparison-details-actual.act-brdr {
  border: 1px solid #FFB57B;
}

.comparison-details-actual.act-fll {
  background-color: #FFB57B;
}

.comparison-details-actual span {
  font-weight: 600;
  color: $font-black;
  margin-left: 5px;
}

.basic-and-recomm-props-wrap {
  width: 376px;
  border-radius: 10px;
  background-color: $common-bg;
  padding: 12px;
}

.p-descr {
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.basic-and-recomm-title {
  text-align: center;
  color: $font-black;
  font-family: "Open Sans";
  font-size: 20px;
  letter-spacing: -0.35px;
  line-height: 27px;
  margin-bottom: 24px;
}

.basic-and-recomm-props {
  height: 22px;
  width: 240px;
  color: #0A1250;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  text-align: right;
  white-space: nowrap;
  /* Запрещаем перенос строк */
  overflow: hidden;
  /* Обрезаем все, что не помещается в область */
  text-overflow: ellipsis;
  /* Добавляем многоточие */
}

.basic-and-recomm-props-descriprion {
  height: 22px;
  width: 99px;
  color: #546C92;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 3px;
}

.recommendation-block {
  height: 115px;
  width: 376px;
  border-radius: 10px;
  padding: 12px;
}

.recommendation-block.success {
  background-color: rgba(167, 220, 89, 0.15);
}

.recommendation-block.reject {
  background-color: #FFF0E5;
}

.recommendation-block-text {
  height: 27px;
  color: #0A1250;
  font-family: "Open Sans";
  font-size: 20px;
  letter-spacing: -0.35px;
  line-height: 27px;
  margin-top: 32px;
  margin-right: 68px;
  /*background: url('../assets/icn_arrow_rounded_Color.svg') no-repeat center ;*/
}

.recommendation-block-icon {
  height: 50px;
  width: 50px;
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgba(26, 41, 60, 0.15);
}

.sign-up-title {
  color: $font-black;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 33px;
  text-align: center;
  margin-bottom: 2px;
}

.sign-up-subtitle {
  color: $font-gray;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
  margin-bottom: 20px;
}

.sign-up-form {
  width: 544px;
  margin: 0 auto;
}

.socialite-btn {
  color: $font-black;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
  height: 48px;
  width: 264px;
  border-radius: 6px;
  background-color: $common-bg;
  border: 1px solid $common-bg;
  margin-right: 16px;
}

.socialite-btn:last-of-type {
  margin-right: 0;
}

.or-block {
  display: block;
  height: 60px;
  width: 100%;
  color: $font-gray;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 48px;
  text-align: center;
  position: relative;
  margin: 0 auto;
}

.or-block:before,
.or-block:after {
  content: '';
  display: block;
  position: absolute;
  z-index: 5;
  height: 1px;
  width: 188px;
  background-color: #D2D9E2;
  top: 24px;
}

.or-block:before {
  left: 0;
}

.or-block:after {
  right: 0;
}

.sign-up-first-name,
.sign-up-last-name,
.sign-up-email {
  height: 48px;
  width: 264px;
  border-radius: 6px;
  background-color: $common-bg;
  color: $font-gray;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  padding: 0 16px;
  border: 1px solid $common-bg;
  outline: none;
}

.sign-up-first-name::placeholder,
.sign-up-last-name::placeholder,
.sign-up-email::placeholder {
  color: $font-gray;
}

.sign-up-first-name:focus,
.sign-up-last-name:focus,
.sign-up-email:focus {
  outline: none;
  background-color: #FFFFFF;
  border: 1px solid #D2D9E2;
}

.sign-up-first-name {
  margin-right: 16px;
}

.sign-up-email {
  width: 100%;
  margin-top: 16px;
}

.btn-default {
  width: 264px;
  display: block;
  margin: 24px auto 0;
}

.justify-content-between {
  justify-content: space-between !important;
}

.margin-left-38 {
  margin-left: 38px;
}

.flex-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.sign-up {
  height: 412px;
}

.full-rep {
  height: 168px;
}

.small-block {
  display: none;
}

@media screen and (max-width: 768px) {
  .speedometer-arrow {
    width: 88px;
    left: 86px;
  }

  .wrap-top-blocks {
    margin-top: -24px;
    padding: 24px;
  }

  .rec-wrap {
    margin-top: 24px;
  }

  .block-rect {
    height: 421px;
    width: 348px;
    padding: 20px;
    margin-bottom: 0;
  }

  .assess-level-text {
    font-size: 12px;
    line-height: 22px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .margin-left-38 {
    margin-left: 0
  }

  .wrap-comparison-level-percent {
    height: 115px;
    width: 308px;
    border-radius: 10px;
    padding: 12px;
    margin-top: 12px;
  }

  .wrap-low-blocks {
    margin-top: -24px;
    padding: 24px;
    flex-direction: column;
  }

  .full-rep {
    width: 720px;
    height: 164px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
  }

  .small-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 70px;
    width: 720px;
    border-radius: 12px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(26, 41, 60, 0.1);
    padding: 13px 200px;
    margin-bottom: 24px;
  }

  .btn-clss {
    width: 320px;
    display: block;
    margin: 0;
  }

  .basic-and-recomm {
    height: 202px;
    width: 100%;
  }

  .basic-and-recomm-props-descriprion {
    width: 118px;
  }

  .basic-and-recomm-props {
    width: 208px;
  }

  .basic-and-recomm-props-wrap {
    width: 100%;
  }

  .recommendation-block {
    width: 100%;
  }
}

@media screen and (max-width: 420px) {
  .basic-and-recomm-title {
    margin-bottom: 20px;
  }

  .rec-wrap {
    margin-top: 0;
  }

  .speedometer-arrow {
    width: 95px;
    left: 96px;
  }

  .wrap-top-blocks {
    margin-top: -24px;
    padding: 0px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .comparison {
    height: 353px;
    width: 390px;
    margin-left: 0;
    margin-top: 6px;
  }

  .block-rect {
    border-radius: 0px;
    padding: 16px;
    width: 390px;
    margin-right: auto;
    margin-left: auto;
  }

  .btn-clss {
    width: 358px;
  }

  .assess-level {
    margin-top: 24px;
    height: 373px;
  }

  .small-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 70px;
    width: 720px;
    border-radius: 12px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 8px 0 rgba(26, 41, 60, 0.1);
    padding: 13px 200px;
    margin-bottom: 24px;
  }

  .btn-clss {
    width: 320px;
    display: block;
    margin: 0;
  }

  .basic-and-recomm {
    height: 202px;
    width: 100%;
  }

  .basic-and-recomm-props-descriprion {
    width: 118px;
  }

  .basic-and-recomm-props {
    width: 208px;
  }

  .basic-and-recomm-props-wrap {
    width: 100%;
  }

  .recommendation-block {
    width: 100%;
  }
}

@media screen and (max-width: 375px) {
  .speedometer-arrow {
    width: 90px;
    left: 89px;
  }

  .block-rect {
    border-radius: 0;
    padding: 16px;
    width: 375px;
    height: 351px;
  }

  .assess-level-title {
    font-size: 16px;
    line-height: 24px;
  }

  .assess-level-subtitle {
    font-size: 11px;
    line-height: 15px;
  }

  .assess-level-text {
    font-size: 11px;
    line-height: 22px;
  }

  .comparison-level-title {
    font-size: 16px;
    line-height: 24px;
  }

  .comparison-level-subtitle {
    font-size: 11px;
    line-height: 15px;
    margin-bottom: 16px;
  }

  .wrap-comparison-level-percent {
    width: 343px;
    border-radius: 10px;
    height: 100px;
  }

  .small-block {
    width: 375px;
  }

  .btn-clss {
    width: 343px;
  }

  .basic-and-recomm-title {
    font-size: 16px;
    line-height: 24px;
  }

  .basic-and-recomm {
    height: 186px;
  }

  .recommendation-block-text {
    font-size: 16px;
    line-height: 27px;
  }

  .rectangle-square {
    height: 76px;
    width: 76px;
    border-radius: 10px;
  }

  .icon-recommend {
    margin: 9px;
  }

  .recommendation-block {
    height: 100px;
    width: 343px;
  }

  .full-rep {
    height: 203px;
  }

  .basic-and-recomm-props-wrap {
    width: 343px;
  }

  .comparison {
    height: 322px;
  }

  .comparison-level-percent {
    font-size: 28px;
    line-height: 27px
  }
}

@media screen and (max-width: 320px) {
  .block-rect {
    width: 320px;
    height: 351px;
  }

  .schkala {
    width: 288px;
  }

  .speedometer-arrow {
    width: 80px;
    left: 75px;
  }

  .assess-level-text {
    flex-direction: column;
  }

  .margin-left-38 {
    margin-left: 0;
  }

  .assess-level {
    height: 400px;
  }

  .wrap-comparison-level-percent {
    width: 288px;
    border-radius: 10px;
    height: 104px;
  }

  .small-block {
    width: 320px;
  }

  .btn-clss {
    width: 288px;
  }

  .basic-and-recomm-props-wrap {
    width: 288px
  }

  .basic-and-recomm-props-descriprion {
    width: 125px;
  }

  .basic-and-recomm {
    height: 186px;
  }

  .basic-and-recomm-title {
    margin-bottom: 16px;
  }

  .recommendation-block {
    width: 288px;
  }

  .full-rep {
    height: 203px;
  }
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: 'Open Sans', sans-serif;
  color: $font-black;
  min-width: 400px;
  box-shadow: 0 2px 8px 0 rgba(26, 41, 60, 0.1);
}

.styled-table thead tr {
  background-color: $light-blue;
  text-align: left;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  white-space: pre-line;
}

.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid $light-blue;
}

.styled-table .table-subheader {
  font-weight: 200;
  font-size: 12px;
  padding: 5px 15px;
  text-transform: uppercase;
}
</style>